import React from 'react';
import {connect} from 'react-redux';
import {connectWithCore} from 'framework/hocs';
import {
  Container,
  Grid,
  Pagination,
  Loader,
  Form,
  Header,
  Button,
} from 'semantic-ui-react';
import {FemaGoTable, FemaGoModal} from 'app-ui-componentlibrary';
import {Link} from 'react-router-dom';
import REST from 'go/requests/rest';
import {compileContent} from 'common/utils';
import {Alert} from 'componentLibrary';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {
  TextBoxField,
  InlineSelect,
  RadioField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {ContentDispatch} from 'framework';
import _ from 'lodash';
import produce from 'immer';
import PanelReviewAddReviewer from './PanelReviewAddReviewer';
import PanelReviewAddChair from './PanelReviewAddChair';

const LOCAL_STORAGE_KEY = 'panelReviewersFilter';
const LOCAL_STORAGE_KEY_SORT = 'panelReviewersSort';

const CLEAR_FILTERS = {
  fullName: '',
  userId: '',
  groupName: '',
  status: '',
};

const CLEAR_SORT = {
  sortBy: 'fullName',
  sortOrder: 'asc',
};

const UPDATE_PROCESS_VARIABLES = 'updateProcessVariables';
const ASSIGN_GROUP = 'assignGroup';

export class ManagePanelReviewersV2 extends React.Component {
  constructor(props) {
    super(props);
    const filtersFromStorage = this.getStoredFilters(LOCAL_STORAGE_KEY);
    const initialFilters = filtersFromStorage ? filtersFromStorage : CLEAR_FILTERS;

    const sortFromStorage = this.getStoredFilters(LOCAL_STORAGE_KEY_SORT);
    const initialSort = sortFromStorage ? sortFromStorage : CLEAR_SORT;

    this.state = {
      uploadError: false,
      reviewers: [],
      pageNum: 0,
      reloadConfiguration: true,
      initializingConfig: true,
      filterSet: 0,
      error: false,
      loading: false,
      numReviewers: 0,
      totalPages: 0,
      masterChecked: false,
      filters: initialFilters,
      sortOptions: initialSort,
      defaultSortOptions: initialSort,
      filterKey: '',
      filterValue: '',
      retrievedFilters: {},
      retrievedSortOptions: {},
      selectionOptions: [],
      selectionIds: [],
      selectionValues: [],
      initializingSelections: true,
      panelChair: this.props.panelChair ? true : false,
      showModal: false,
    };
  }

  componentDidMount() {
    const {id} = this.props.context.auth.userId;
    const filtersRetrieved = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    const sortOptionsRetrieved = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_SORT));

    if (sortOptionsRetrieved && !this.state.panelChair) {
      if (sortOptionsRetrieved.loginId !== id) {
        localStorage.setItem(LOCAL_STORAGE_KEY_SORT, JSON.stringify({}));
      } else {
        this.setState({
          retrievedSortOptions: sortOptionsRetrieved,
        });
      }
    }

    if (filtersRetrieved && !this.state.panelChair) {
      if (filtersRetrieved.loginId !== id) {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({}));
      } else {
        this.setState({
          retrievedFilters: filtersRetrieved,
        });
      }
    }
    if (!this.state.panelChair) {
      this.getReviewers();
      this.loadPossibleFilterValues();
    } else {
      this.getChairs();
    }
  }

  openManageTeamModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };

  getChairs = _.debounce(
    () => {
      this.setState({
        loading: true,
      });

      const {token, sessionId} = this.props;
      REST.panelReviewV2
        .getChairsBySession(token, sessionId, this.state.pageNum)
        .then(REST.handler.handleResponse)
        .then((chairsRes) => {
          if (_.size(_.get(chairsRes, 'content')) === 0) {
            this.setState({
              error: true,
              loading: false,
            });
          } else {
            const chairs = _.get(chairsRes, 'content');
            let mappedChairs;
            const uniqueUserIds = _.uniq(
              _.map(chairs, (chair) => _.get(chair, 'panelChairPK.userId'))
            );
            let userIdPayload = {
              userId: uniqueUserIds,
            };
            REST.user
              .getProfilesForUsers(token, userIdPayload)
              .then(REST.handler.handleResponse)
              .then((usersData) => {
                if (!_.isNull(usersData)) {
                  mappedChairs = _.map(chairs, (chair) => {
                    const matchUser = _.find(usersData, {
                      userId: _.get(chair, 'panelChairPK.userId'),
                    });
                    const firstName = _.get(matchUser, 'firstName')
                      ? _.get(matchUser, 'firstName')
                      : '';
                    const lastName = _.get(matchUser, 'lastName')
                      ? _.get(matchUser, 'lastName')
                      : '';
                    const id = _.get(chair, 'panelChairPK.userId');
                    return {
                      userId: id,
                      ...chair,
                      mappedFullName: `${firstName} ${lastName}`,
                    };
                  });
                  this.setState({
                    reviewers: _.sortBy(mappedChairs, ['mappedFullName']),
                    allReviewers: _.sortBy(mappedChairs, ['mappedFullName']),
                    error: false,
                    loading: false,
                    numReviewers: _.get(chairsRes, 'totalElements'),
                    totalPages: _.get(chairsRes, 'totalPages'),
                  });
                }
              });
          }
        })
        .catch((err) => {
          this.setState({
            error: true,
            loading: false,
            initializingData: false,
          });
        });
    },
    250,
    {loading: true}
  );

  getReviewers = _.debounce(
    () => {
      this.setState({
        loading: true,
      });

      const {token, sessionId} = this.props;
      const {filters} = this.state;

      let fetchBody = {
        search: [],
        filters: [],
        sorting: [],
      };

      const {sortOptions} = this.state;
      const {sortBy, sortOrder, sortType} = sortOptions;

      fetchBody.sorting.push({
        sortBy: sortBy ? sortBy : 'fullName',
        sortOrder: sortOrder ? sortOrder : 'asc',
        sortType: sortType ? sortType : 'string',
      });

      //Handle search filters...
      let enumeratedValues = this.state.variableValues;
      _.forEach(_.keys(filters), (key) => {
        let enumeratedObj = _.filter(enumeratedValues, (obj) => {
          return obj[key];
        });
        if (key !== 'loginId') {
          if (filters[key] || filters[key] === 0 || filters[key] === false) {
            let filterValue = filters[key];
            if (typeof filterValue === 'string' && _.isEmpty(enumeratedObj)) {
              fetchBody.search.push({
                name: key,
                value: `%${filterValue}%`,
                operator: 'like',
              });
            } else {
              fetchBody.filters.push({
                name: key,
                value: filterValue,
                operator: 'eq',
              });
            }
          }
        }
      });
      REST.panelReviewV2
        .reviewersSearch(token, sessionId, this.state.pageNum, fetchBody)
        //.getReviewersBySession(token, sessionId, this.state.pageNum)
        .then(REST.handler.handleResponse)
        .then((reviewersRes) => {
          if (_.size(_.get(reviewersRes, 'pageList')) === 0) {
            this.setState({
              error: true,
              loading: false,
            });
          } else {
            const reviewers = _.get(reviewersRes, 'pageList');
            this.setState({
              reviewers: reviewers,
              error: false,
              loading: false,
              numReviewers: _.get(reviewersRes, 'nrOfElements'),
              totalPages: _.get(reviewersRes, 'pageCount'),
            });
          }
        })
        .catch((err) => {
          this.setState({
            error: true,
            loading: false,
            initializingData: false,
          });
        });
    },
    250,
    {loading: true}
  );

  getStoredFilters = (key) => {
    const {id} = this.props;
    const filter = JSON.parse(localStorage.getItem(key)) || {};
    if (filter) {
      if (filter.loginId !== id) {
        localStorage.setItem(key, JSON.stringify({}));
      } else return filter;
    }
    return {};
  };

  loadPossibleFilterValues = () => {
    const {token, sessionId} = this.props;
    let filterMap = [];
    let status = ['Active', 'Inactive'];
    filterMap.push({['status']: status});

    REST.panelReviewV2
      .getGroupNamesBySession(token, sessionId)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        let data = [];
        resJson.forEach((entry) => {
          data.push(entry.name);
        });
        filterMap.push({['groupName']: _.sortedUniq(data)});
      })
      .catch((error) => {
        console.error('error');
      });
    this.setState({
      variableValues: filterMap,
    });
  };

  setUploadError = (error) => {
    this.setState({uploadError: error});
  };

  setFilter = (name, value) => {
    const {retrievedFilters} = this.state;
    const id = this.props.context.auth.userId;
    const newRetrievedFilters = {
      ...retrievedFilters,
      [name]: value,
      loginId: id,
    };
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newRetrievedFilters));
    this.setState(
      {
        filters: newRetrievedFilters,
        retrievedFilters: newRetrievedFilters,
      },
      () => {
        this.onFilterChange(newRetrievedFilters);
      }
    );
  };

  onFilterChange = (filters, resetSort) => {
    const id = this.props.context.auth.userId;
    const defaultSort = {
      sortBy: 'fullName',
      sortOrder: 'asc',
    };
    const sortOptions = resetSort ? defaultSort : this.state.sortOptions;
    localStorage.setItem(
      LOCAL_STORAGE_KEY_SORT,
      JSON.stringify({...sortOptions, loginId: id})
    );
    this.setState(
      {
        firstResult: 0,
        activePage: 1,
        filters: filters,
        filterSet: this.state.filterSet + 1,
        sortOptions,
      },
      this.getReviewers
    );
  };

  clearAllFilters = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({}));
    localStorage.setItem(LOCAL_STORAGE_KEY_SORT, JSON.stringify({}));
    this.onFilterChange(CLEAR_FILTERS, true);
  };

  setSortBy = (sortBy, sortType) => {
    const {sortOptions} = this.state;
    this.setSort({
      ...sortOptions,
      sortBy,
      sortType,
    });
  };

  setSortOrder = (sortOrder) => {
    const {sortOptions} = this.state;
    this.setSort({
      ...sortOptions,
      sortOrder,
    });
  };

  setSort = (sortOptions) => {
    const id = this.props.context.auth.userId;
    this.setState({
      sortOptions,
      activePage: 1,
      firstResult: 0,
      filterSet: this.state.filterSet + 1,
    });
    localStorage.setItem(
      LOCAL_STORAGE_KEY_SORT,
      JSON.stringify({...sortOptions, loginId: id})
    );
    this.getReviewers();
  };

  handlePageChange = async (e, {activePage}) => {
    await this.setState({pageNum: activePage - 1});
    if (!this.state.panelChair) {
      this.getReviewers();
    } else {
      this.getChairs();
    }
  };

  handleMasterCheckbox = (value) => {
    let data = produce(this.state.reviewers, (draftResults) => {
      _.forEach(draftResults, (entry) => {
        entry.checked = value;
      });
    });
    this.setState({
      reviewers: data,
      masterChecked: value,
    });
  };

  handleCheckboxChange = (userId, value) => {
    let data = this.state.reviewers;
    let index = _.findIndex(data, {userId}) || 0;
    const updatedData = produce(data, (draft) => {
      let taskToUpdate = _.get(draft, index);
      _.set(taskToUpdate, 'checked', value);
    });
    this.setState({
      reviewers: updatedData,
    });
  };

  onSelectBulkAction = (e) => {
    if (!_.isEmpty(e.target.value)) {
      const key = e.target.value;
      this.setState({
        selectedBulkAction: key,
        selectedBulkActionName: e.target.textContent,
        isBulkModalOpen: true,
        showSuccessMessage: false,
        showErrorMessage: false,
      });
    }
  };

  getNumberOfSelectedRows() {
    let count = 0;
    _.forEach(this.state.reviewers, (reviewer) => {
      if (reviewer.checked) count++;
    });
    return count;
  }

  processBatchAction = () => {
    const {selectedGroup} = this.props;
    const selectedIds = this.getSelectedIds();
    const {selectedBulkAction: bulkAction} = this.state;
    this.setState({
      modalProcessing: true,
      selectedResults: selectedIds.selectedResults,
    });
    const {config} = this.props;
    const action = _.chain(config)
      .get('actions', [])
      .find((action) => {
        return action.key === bulkAction;
      })
      .value();
    this.handleMasterCheckbox(false);
    const actionType = _.get(action, 'type', UPDATE_PROCESS_VARIABLES);

    let bulkHandler = (selectedIds, action) => {
      if (actionType === UPDATE_PROCESS_VARIABLES) {
        return this.processBulkStatusUpdate(selectedIds, action);
      } else if (actionType === ASSIGN_GROUP) {
        return this.processBulkAssignToGroup(selectedIds, selectedGroup, action);
      }
    };

    bulkHandler(selectedIds, action)
      .catch((error) => {
        // Refreshing data
        this.setState({
          processingAction: action,
          selectedResults: selectedIds.selectedResults,
          showErrorMessage: true,
          //results: undefined,
          modalProcessing: false,
        });
        console.error('Error processing bulk update');
      })
      .finally(() => {
        this.setState({
          isBulkModalOpen: false,
          selectedBulkAction: '--',
          selectedBulkActionName: '--',
          modalProcessing: false,
        });
        this.props.saveEntitySessionData('context.selectedGroupName', '');
        if (document && document.getElementById('root'))
          document.getElementById('root').scrollTop = 0; // Workaround when window.scrollTo does not work
      });

    if (!this.state.panelChair) {
      this.getReviewers();
    } else {
      this.getChairs();
    }
  };

  processBulkStatusUpdate = (selectedIds, action) => {
    const actionKey = _.get(action, 'key');
    let status = '';
    if (actionKey === 'activeStatus') {
      status = 'active';
    } else if (actionKey === 'inactiveStatus') {
      status = 'inactive';
    }
    if (!this.state.panelChair) {
      return REST.panelReviewV2
        .setBulkStatus(selectedIds.emailIds, this.props.sessionId, status)
        .then(REST.handler.handleResponse)
        .then((resJson) => {
          // Refreshing data
          this.setState({
            selectedResults: selectedIds.emailIds,
            processingAction: action,
            showSuccessMessage: true,
          });
        });
    } else {
      return REST.panelReviewV2
        .updateSuspendedDataForChair(selectedIds.emailIds, this.props.sessionId, status)
        .then(REST.handler.handleResponse)
        .then((resJson) => {
          // Refreshing data
          this.setState({
            selectedResults: selectedIds.emailIds,
            processingAction: action,
            showSuccessMessage: true,
          });
        });
    }
  };

  processBulkAssignToGroup = (selectedIds, group, action) => {
    return REST.panelReviewV2
      .setBulkGroup(selectedIds.emailIds, this.props.sessionId, group)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        // Refreshing data
        this.setState({
          selectedResults: selectedIds.emailIds,
          processingAction: action,
          showSuccessMessage: true,
        });
      });
  };

  getSelectedIds() {
    let emailIds = [];
    _.forEach(this.state.reviewers, (reviewer) => {
      if (reviewer.checked) {
        emailIds.push(reviewer.userId);
      }
    });
    return {emailIds};
  }

  getSelectedEmails() {
    let emailIds = [];
    _.forEach(this.state.reviewers, (reviewer) => {
      if (reviewer.checked) {
        emailIds.push(reviewer.emailAdr);
      }
    });
    return {emailIds};
  }

  addReviewerRole = async (newReviewerId) => {
    let {token, sessionId} = this.props;

    let reviewerBody = {
      sessionId: +sessionId,
      userId: newReviewerId,
      emailAdr: newReviewerId,
      firstName: '',
      lastName: '', // First and last name will be removed from schema but necessary for current POST Call
      suspended: true,
    };

    await REST.panelReviewV2.addReviewer(token, sessionId, reviewerBody).catch((e) => {
      this.setState({error: true});
    });
  };

  saveReviewerRole = async (selectedFile) => {
    if (!this.state.uploadError) {
      this.setState({loading: true});
      await this.uploadedFileData(selectedFile);
    }
  };

  addChairRole = async (newChairId) => {
    let {token, sessionId} = this.props;

    let chairBody = {
      sessionId: +sessionId,
      userId: newChairId,
      firstName: '',
      lastName: '', // First and last name will be removed from schema but necessary for current POST Call
      suspended: true,
    };

    await REST.panelReviewV2.addChair(token, sessionId, chairBody).catch((e) => {
      this.setState({error: true});
    });
  };

  saveChairRole = async (selectedFile) => {
    if (!this.state.uploadError) {
      await this.uploadedFileDataChairs(selectedFile);
    }
  };

  uploadedFileData = async (file) => {
    let {token, sessionId} = this.props;

    let data = new FormData();
    data.append('bulkPanelistSpreadsheet', file.file);
    this.setState({
      loading: true,
    });
    await REST.panelReviewV2
      .uploadFileData(token, sessionId, data)
      .then((res) => res.json())
      .then((res) => {
        const {errorCode, error = ''} = res;
        this.setState({
          error: errorCode != undefined,
          errorCode: errorCode,
          errorText: error,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        if (error) {
          this.setState({error: true});
        }
      });
  };

  uploadedFileDataChairs = async (file) => {
    let {token, sessionId} = this.props;

    let data = new FormData();
    data.append('bulkPanelistSpreadsheet', file.file);
    this.setState({
      loading: true,
    });
    await REST.panelReviewV2
      .uploadFileDataChairs(token, sessionId, data)
      .then((res) => res.json())
      .then((res) => {
        const {errorCode, error = ''} = res;
        this.setState({
          error: errorCode != undefined,
          errorCode: errorCode,
          errorText: error,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        if (error) {
          this.setState({error: true});
        }
      });
  };

  renderMessages = (showSuccess, showError) => {
    if (showSuccess || showError) {
      const {processingAction, selectedResults} = this.state;
      const submissionVariables = _.get(this.props, 'submissionVariables', {});

      const modalConfig = _.get(processingAction, 'modal', {});

      const successMessageHeader = modalConfig.successMessageHeader;
      const successMessageContent = compileContent(modalConfig.successMessageContent, {
        selectedCount: _.size(selectedResults),
        ...submissionVariables,
      });
      const errorMessageHeader = modalConfig.errorMessageHeader;
      const errorMessageContent = compileContent(modalConfig.errorMessageContent, {
        userIds: _.join(selectedResults, ', '),
        ...submissionVariables,
      });

      return (
        <React.Fragment>
          {showSuccess && selectedResults && selectedResults.length > 0 ? (
            <Alert
              key="successMessage"
              header={successMessageHeader}
              content={successMessageContent}
              type="success"
              onDismiss={() => this.setState({showSuccessMessage: false})}
              dismissable
            />
          ) : (
            ''
          )}
          {showError ? (
            <Alert
              key="failureMessage"
              header={errorMessageHeader}
              content={errorMessageContent}
              type="error"
              onDismiss={() => this.setState({showErrorMessage: false})}
              dismissable
            />
          ) : (
            ''
          )}
        </React.Fragment>
      );
    }
  };

  renderModal = () => {
    const {selectedBulkAction, isBulkModalOpen, modalProcessing} = this.state;
    const {config, toggles} = this.props;
    const userEmailTable = _.includes(toggles, 'userEmailTable');
    const {selectedGroup: groupName} = this.props;
    const submissionVariables = _.get(this.props, 'submissionVariables', {});
    const selectedCount = this.getNumberOfSelectedRows();
    const selectedIds = this.getSelectedIds();
    const selectedEmails = this.getSelectedEmails();
    const selectedBulkActionConfig = _.find(
      _.get(config, 'actions', []),
      (action) => action.key === selectedBulkAction
    );
    let validationsSuccesful = true;
    const modalConfig = _.get(selectedBulkActionConfig, 'modal');
    const modalTitle = _.get(modalConfig, 'modalTitle', '');
    if (modalTitle === 'Assign to group') {
      if (groupName == undefined || _.isEmpty(groupName)) {
        validationsSuccesful = false;
      }
    }
    const modalContent = compileContent(_.get(modalConfig, 'modalContent', ''), {
      selectedCount,
      groupName,
      userIds: userEmailTable && !this.state.panelChair ? selectedEmails : selectedIds,
      ...submissionVariables,
    });
    const modalSubmitText = _.get(modalConfig, 'modalSubmitButton', 'Confirm');
    const contents = _.get(modalConfig, 'contents', []);

    return (
      <FemaGoModal
        title={modalTitle}
        buttonText={modalSubmitText}
        open={!!isBulkModalOpen}
        confirmAction={this.processBatchAction}
        cancelAction={() =>
          this.setState({
            isBulkModalOpen: false,
            selectedBulkAction: '--',
            selectedBulkActionName: '--',
            modalProcessing: false,
          })
        }
        disableButton={!validationsSuccesful || modalProcessing}
        htmlContent={modalContent}
      >
        {_.map(contents, (conf, index) => {
          let config = {
            ...conf,
          };
          return <ContentDispatch key={conf.id || index} config={config} />;
        })}
      </FemaGoModal>
    );
  };

  renderTable(reviewers) {
    const {toggles} = this.props;
    const userEmailTable = _.includes(toggles, 'userEmailTable');
    let reviewerEmail = userEmailTable && !this.state.panelChair ? 'emailAdr' : 'userId';

    if (reviewers && reviewers.length && !this.state.panelChair) {
      return reviewers.map((reviewer) => {
        return (
          <FemaGoTable.Row key={reviewer.userId}>
            <FemaGoTable.CheckboxCell
              key={reviewer.userId + 'checkboxCell'}
              label={'Reviewer with Id ' + reviewer.userId}
              hideLabel={true}
              collapsing={true}
              checked={reviewer.checked}
              handleChange={(label, value) =>
                this.handleCheckboxChange(reviewer.userId, value)
              }
            />
            <FemaGoTable.TextCell>{_.get(reviewer, 'fullName')}</FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              <Link
                to={`/panelReview/admin/sessions/${reviewer.sessionId}/reviewers/${reviewer.userId}`}
              >
                {_.get(reviewer, reviewerEmail)}
              </Link>
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {reviewer.suspended ? 'Inactive' : 'Active'}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {_.isNil(reviewer.groupName) ? 'N/A' : reviewer.groupName}
            </FemaGoTable.TextCell>
          </FemaGoTable.Row>
        );
      });
    } else if (reviewers && reviewers.length) {
      return reviewers.map((reviewer) => {
        return (
          <FemaGoTable.Row key={reviewer.userId}>
            <FemaGoTable.CheckboxCell
              key={reviewer.userId + 'checkboxCell'}
              label={'Panel Chair with Id ' + reviewer.userId}
              hideLabel={true}
              collapsing={true}
              checked={reviewer.checked}
              handleChange={(label, value) =>
                this.handleCheckboxChange(reviewer.userId, value)
              }
            />
            <FemaGoTable.TextCell>
              {_.get(reviewer, 'mappedFullName')}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>{_.get(reviewer, reviewerEmail)}</FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {reviewer.suspended ? 'Inactive' : 'Active'}
            </FemaGoTable.TextCell>
          </FemaGoTable.Row>
        );
      });
    } else {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.TextCell> </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    }
  }

  render() {
    const {
      showSuccessMessage,
      showErrorMessage,
      filters,
      loading,
      error,
      reviewers,
      masterChecked,
      variableValues,
      sortOptions,
    } = this.state;

    const {config} = this.props;

    const configActions = _.reduce(
      (config || {}).actions,
      (result, action) => {
        result.push({
          key: action.key,
          text: action.name,
          value: action.key,
        });
        return result;
      },
      []
    );

    const actions = [
      {
        key: '',
        value: '',
        text: '',
      },
      ...configActions,
    ];

    const sortBy = _.chain(config)
      .get(['sortBy'], [])
      .reduce((result, col) => {
        result.push({
          key: col.key,
          text: col.label,
          value: col.key,
          type: col.type ? col.type : 'string',
        });
        return result;
      }, [])
      .value();

    const sortType = (selectedValue) => {
      let selectedItem = _.find(sortBy, (item) => {
        return item.key === selectedValue;
      });
      return selectedItem.type;
    };

    const search = _.map(config.filters, (filterKey) => {
      return (
        <TextBoxField
          key={filterKey.name}
          title={filterKey.title}
          value={filters[filterKey.name] || ''}
          name={filterKey.name}
          label={filterKey.label}
          id={filterKey.name}
          handleChange={(e) => {
            this.setFilter(e.target.name, e.target.value);
          }}
        />
      );
    });

    const enumeratedFilters = _.map(config.enumeratedFilters, (filterKey) => {
      let optionValue = [{key: '', value: null, text: ''}];
      _.forEach(_.find(variableValues, filterKey.name), (varValues) => {
        _.forEach(varValues, (varValue) => {
          optionValue.push({
            key: varValue,
            value: varValue,
            text: varValue,
          });
        });
      });

      return (
        <InlineSelect
          key={filterKey.name}
          placeholder={filterKey.placeholder}
          id={filterKey.name}
          label={filterKey.label}
          selection
          title={filterKey.title}
          name={filterKey.name}
          value={filters[filterKey.name]}
          handleChange={(e) => {
            this.setFilter(e.target.name, e.target.value);
          }}
          options={optionValue}
        />
      );
    });

    var sortByValue = sortOptions.sortBy;
    if (
      !_.isEmpty(sortOptions) &&
      _.isEmpty(
        _.find(sortBy, (item) => {
          return item.key === sortOptions.sortBy;
        })
      )
    ) {
      sortByValue = _.get(sortBy, 0, {}).key;
    }

    return (
      <Main>
        <Container fluid>
          {this.renderMessages(showSuccessMessage, showErrorMessage)}
          <Grid doubling stackable reversed="mobile" padded="vertically">
            <React.Fragment>
              <Grid.Column width={16}>
                <Button
                  primary
                  onClick={() => {
                    this.openManageTeamModal();
                  }}
                >
                  {this.state.panelChair ? 'Add panel chair' : 'Add reviewer'}
                </Button>
                {this.state.panelChair ? (
                  <PanelReviewAddChair
                    loading={this.state.loading}
                    openManageTeamModal={this.openManageTeamModal.bind(this)}
                    closeManageTeamModal={this.openManageTeamModal.bind(this)}
                    showModal={this.state.showModal}
                    addChairRole={this.addChairRole}
                    saveChairRole={this.saveChairRole}
                    getChairs={this.getChairs}
                    uploadError={this.state.uploadError}
                    setUploadError={this.setUploadError}
                  />
                ) : (
                  <PanelReviewAddReviewer
                    loading={this.state.loading}
                    openManageTeamModal={this.openManageTeamModal.bind(this)}
                    closeManageTeamModal={this.openManageTeamModal.bind(this)}
                    showModal={this.state.showModal}
                    addReviewerRole={this.addReviewerRole}
                    saveReviewerRole={this.saveReviewerRole}
                    getReviewers={this.getReviewers}
                    uploadError={this.state.uploadError}
                    setUploadError={this.setUploadError}
                  />
                )}
              </Grid.Column>
              {error ? (
                this.state.panelChair ? (
                  <React.Fragment>
                    <Grid.Column width={12}>
                      <p>No panel chairs assigned at this time.</p>
                    </Grid.Column>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Grid.Column width={12}>
                      <p>No reviewers assigned at this time.</p>
                    </Grid.Column>
                  </React.Fragment>
                )
              ) : (
                <React.Fragment>
                  {this.state.loading ? (
                    <Loader inline="centered" active>
                      Loading...
                    </Loader>
                  ) : (
                    <Grid.Column width={12}>
                      <FemaGoTable
                        summary={
                          this.state.panelChair
                            ? 'Manage panel chairs table'
                            : 'Manage reviewers table'
                        }
                      >
                        <FemaGoTable.Header>
                          <FemaGoTable.Row>
                            <FemaGoTable.CheckboxCell
                              key="headerCheckbox"
                              isHeader
                              label={
                                this.state.panelChair
                                  ? 'Select All Chairs'
                                  : 'Select All Reviewers'
                              }
                              hideLabel={true}
                              className="header-checkbox"
                              collapsing={true}
                              checked={masterChecked}
                              handleChange={(label, value) =>
                                this.handleMasterCheckbox(value)
                              }
                            />
                            <FemaGoTable.HeaderCell>Name</FemaGoTable.HeaderCell>
                            <FemaGoTable.HeaderCell>Email</FemaGoTable.HeaderCell>
                            <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                            {!this.state.panelChair ? (
                              <FemaGoTable.HeaderCell>Group name</FemaGoTable.HeaderCell>
                            ) : (
                              <></>
                            )}
                          </FemaGoTable.Row>
                        </FemaGoTable.Header>
                        <FemaGoTable.Body>{this.renderTable(reviewers)}</FemaGoTable.Body>
                      </FemaGoTable>
                      <div className="reviewer-action-select">
                        <InlineSelect
                          key="reviewerActionSelect"
                          placeholder="--"
                          id="batchAction"
                          search
                          selection
                          title="Select Batch Action"
                          name="selectedAction"
                          label="Select an action"
                          value=""
                          handleChange={this.onSelectBulkAction}
                          options={actions}
                          disabled={
                            this.getNumberOfSelectedRows() === 0 || actions.length === 0
                          }
                        />
                      </div>
                      <div className="pagination-wrapper pagination">
                        <Pagination
                          activePage={this.state.pageNum + 1}
                          firstItem={null}
                          lastItem={null}
                          siblingRange={1}
                          boundaryRange={1}
                          ellipsisItem={null}
                          totalPages={this.state.totalPages}
                          onPageChange={this.handlePageChange}
                        ></Pagination>
                      </div>
                      {this.renderModal()}
                    </Grid.Column>
                  )}
                </React.Fragment>
              )}
              {!this.state.panelChair ? (
                <Grid.Column width={4} key="reviewerListFilterColumn">
                  <Form>
                    <Header as="h6" textAlign="right">
                      <a
                        href="#"
                        className="table-link"
                        tabIndex="0"
                        onClick={this.clearAllFilters}
                      >
                        Clear Filters
                      </a>
                    </Header>
                    <Header as="h3">Search</Header>
                    {search}
                    <Header as="h3">Filters</Header>
                    {enumeratedFilters}
                    <Header as="h3">Sort</Header>
                    <InlineSelect
                      placeholder="Sort by"
                      search
                      selection
                      title="Sort"
                      value={sortByValue}
                      name="sortBy"
                      id="sortBy"
                      label="Sort by"
                      handleChange={(e) => {
                        this.setSortBy(e.target.value, sortType(e.target.value));
                      }}
                      options={sortBy}
                    />
                    <Form.Field>
                      <RadioField
                        name="sortOrder"
                        handleChange={(e) => {
                          this.setSortOrder(e.target.value);
                        }}
                        value={_.get(sortOptions, 'sortOrder', 'asc')}
                        options={[
                          {label: 'Ascending (A-Z)', value: 'asc'},
                          {label: 'Descending (Z-A)', value: 'desc'},
                        ]}
                      />
                    </Form.Field>
                  </Form>
                </Grid.Column>
              ) : (
                <></>
              )}
            </React.Fragment>
          </Grid>
        </Container>
      </Main>
    );
  }
}

export const mapStateToProps = (state) => {
  // things needed for bulk assign group context
  const loginId = state.auth.userId;
  const groupName = _.get(state, 'dynamicComponent.context.selectedGroupName');
  let submissionVariables = {
    ..._.get(state, 'dynamicComponent.context.panelReviewerGroups', {}),
    groupName: groupName,
    userId: loginId,
  };
  return {
    id: loginId,
    selectedGroup: groupName,
    submissionVariables,
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps)(connectWithCore(ManagePanelReviewersV2));
